import React, { forwardRef } from 'react';

export const RadioInputField = forwardRef(({ label, value, ...rest }, ref) => {
  return (
    <div className="w--full">
      <label
        className="label--control d--flex gap--sm font--sm font--500 text--black c--pointer"
        htmlFor={`${rest?.name}_${label}`}
      >
        <input
          type="radio"
          className="form--control no--focus"
          id={`${rest?.name}_${label}`}
          value={value}
          {...rest}
          name={rest?.name}
          ref={ref}
        />
        {label}
      </label>
    </div>
  );
});
